<script setup lang="ts">
import GearSolid from "@/Components/Icons/GearSolid.vue";
import NavFlyoutButton from "@/Components/Nav/NavFlyoutButton.vue";
import InvoiceIcon from "@/Components/Icons/InvoiceIcon.vue";
import NavLink from "@/Components/Nav/NavLink.vue";
import type NavLinkType from "@/Types/NavLink";
import { computed } from "vue";

defineProps({
    expanded: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(["click-link"]);

const navLinks = computed((): NavLinkType[] => [
    {
        label: "Buckets",
        icon: GearSolid,
        visible: true,
        active: route().current("bucket.*"),
        href: route("bucket.edit"),
    },
    {
        label: "Billing",
        icon: InvoiceIcon,
        visible: true,
        active: route().current("billing.*"),
        href: route("spark.portal"),
    },
]);
</script>

<template>
    <div>
        <div
            v-for="link in navLinks"
            :key="link.label"
        >
            <NavLink
                v-if="'href' in link && link.visible"
                :href="link.href"
                :active="link.active ?? false"
                :label="link.label"
                :expanded="expanded"
                :icon="link.icon"
                @click="emit('click-link')"
            />

            <NavFlyoutButton
                v-if="'children' in link && link.visible"
                :label="link.label"
                :expanded="expanded"
                :icon="link.icon"
                :active="link.active"
                :children="link.children"
                @click-link="emit('click-link')"
            />
        </div>
    </div>
</template>
